import './assets/main.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faBars,
  faBuilding,
  faChartLine,
  faClipboardCheck,
  faCode,
  faCreditCard,
  faEnvelope,
  faFax,
  faFileLines,
  faGasPump,
  faLocationDot,
  faLock,
  faPhone,
  faTruck,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
  faXing
} from '@fortawesome/free-brands-svg-icons';

import tooltip from './directives/tooltip';

library.add(
  faBars,
  faXmark,
  faArrowRight,
  faFileLines,
  faTruck,
  faChartLine,
  faGasPump,
  faBuilding,
  faPhone,
  faFax,
  faEnvelope,
  faCreditCard,
  faClipboardCheck,
  faCode,
  faLock,
  faLocationDot,
  faLinkedin,
  faTwitter,
  faXing,
  faFacebook,
  faInstagram
);

import App from './App.vue';
import i18n, { initializeLocale } from './i18n';
import router from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);

// Registriere die Direktiven
app.directive('tooltip', tooltip);

// Initialisiere die Sprache
initializeLocale();

app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');
